import { FC, useMemo } from 'react';
import { useQuery } from 'urql';
import { MedicalInstitutionTop } from '~/components/features/medical-institution/MedicalInstitutionTop/MedicalInstitutionTop';
import { MedicalInstitutionTopByKeyDocument } from 'gen/medinavi-backend-consumer-graphql/graphql';
import { HandledError } from '~/types/handled-error';

type Props = {
  hospitalUserKey: string;
};

export const MedicalInstitutionTopByKey: FC<Props> = ({ hospitalUserKey }) => {
  const [institution] = useQuery({
    query: MedicalInstitutionTopByKeyDocument,
    variables: {
      facilityMemberKey: hospitalUserKey,
    },
  });

  const canonicalUrl = useMemo(() => {
    const url = new URL('/medical_institution/introduction', process.env.NEXT_PUBLIC_MEDICO_URL as string);

    url.searchParams.set('hospital_user_key', hospitalUserKey);

    return url.toString();
  }, [hospitalUserKey]);

  if (institution?.data?.medicoFacilityByFacilityMemberKey == null) {
    // TODO captureしなくて良い？？
    throw new HandledError(new Error('medicoFacilityByFacilityMemberKey must be non-null'), {
      shouldSendToSentry: false,
      requireReStart: false,
    });
  }

  return (
    <MedicalInstitutionTop
      keyOrId={hospitalUserKey}
      canonicalUrl={canonicalUrl}
      institution={institution.data.medicoFacilityByFacilityMemberKey}
    />
  );
};
